import React from "react";
import "./Player.css"

const Player = (props) => {
  const {  
    artist, 
    title ,            
    isPlaying,
    onPrevClick,
    onNextClick,
    onPlayPauseClick,
    onStopClick
  } = props
  return (
    <div className="musicplayer">
      {/* Player Display */}
      <div className="musicplayer_top">
        <div className="musicplayer_top_artist">{artist}</div>
        <div className="musicplayer_top_title">{title}</div>
      </div>

      {/* Player controls */}
      <div className="musicplayer_bottom">
        {/* Previous */}
        <div className="musicplayer_button material-icons icon--large" onClick={onPrevClick}>skip_previous</div>
        {/* Stop */}
        <div className="musicplayer_button material-icons icon--large" onClick={onStopClick}>stop</div>
        {/* Play/Pause */}
        {isPlaying ? (
          <div className="musicplayer_button material-icons icon--large" onClick={() => onPlayPauseClick(false)}>pause</div>
        ) : (
          <div className="musicplayer_button material-icons icon--large" onClick={() => onPlayPauseClick(true)}>play_arrow</div>
        )}
        {/* Next */}
        <div className="musicplayer_button material-icons icon--large" onClick={onNextClick}>skip_next</div>
      </div>
    </div>
  )
}

export default Player